import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-green-900 text-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold text-yellow-400 mb-4">REZCOM INTERNATIONAL</h3>
            <p className="text-gray-300 mb-4">
              Tu socio confiable en logística internacional. Conectamos tu negocio con el mundo 
              a través de soluciones de transporte innovadoras y eficientes.
            </p>
            <div className="flex items-center space-x-2 text-gray-300">
              <Clock className="w-4 h-4" />
              <span>24/7 Servicio al Cliente</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Servicios</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Logística Internacional
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Transporte Terrestre
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Carga Aérea
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Almacenamiento
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Distribución Global
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Inicio
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Sobre Nosotros
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Blog
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Cotización
              </li>
              <li className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
                Contacto
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-yellow-400" />
                <span>+52 556 215 2214</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-yellow-400" />
                <span>contacto@rezcom-intl.mx</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-yellow-400 mt-1" />
                <span>Ciudad de México, México</span>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="border-t border-green-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm mb-4 md:mb-0">
            © 2025 REZCOM INTERNATIONAL. Todos los derechos reservados.
          </p>
          
          <motion.button
            onClick={scrollToTop}
            className="bg-yellow-500 hover:bg-yellow-600 text-black p-2 rounded-full transition-all duration-300"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <ArrowUp className="w-5 h-5" />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;